import { Brand, createBranded } from '@deltasierra/type-utilities';

const ACCOUNT_RESOURCE_NAME_REGEX = /\/?accounts\/(\d+)/i;

export type GoogleMyBusinessAccountResourceId = Brand<`${number}`, 'GoogleMyBusinessAccountResourceId'>;
export const GoogleMyBusinessAccountResourceId = createBranded<GoogleMyBusinessAccountResourceId>();

export type GoogleMyBusinessAccountResourceName = Brand<
    `/accounts/${GoogleMyBusinessAccountResourceId}`,
    'GoogleMyBusinessAccountResourceName'
>;
export const GoogleMyBusinessAccountResourceName = Object.freeze({
    from(name: string): GoogleMyBusinessAccountResourceName {
        if (!GoogleMyBusinessAccountResourceName.matches(name)) {
            throw new TypeError(`Failed to parse invalid account resource name: "${name}"`);
        }
        return name;
    },
    getAccountResourceId(name: GoogleMyBusinessAccountResourceName): GoogleMyBusinessAccountResourceId {
        const match = ACCOUNT_RESOURCE_NAME_REGEX.exec(name);
        if (match && match.length && match[1]) {
            return GoogleMyBusinessAccountResourceId.from(match[1]);
        } else {
            throw new TypeError(`'${name}' is not a GoogleMyBusinessAccountResourceName`);
        }
    },
    matches(name: string): name is GoogleMyBusinessAccountResourceName {
        return ACCOUNT_RESOURCE_NAME_REGEX.test(name);
    },
});

const BUSINESS_LOCATION_RESOURCE_NAME_REGEX = /\/?accounts\/\d+\/locations\/(\d+)/i;

export type GoogleMyBusinessLocationResourceId = Brand<`${number}`, 'GoogleMyBusinessLocationResourceId'>;
export const GoogleMyBusinessLocationResourceId = createBranded<GoogleMyBusinessLocationResourceId>();

export type GoogleMyBusinessLocationResourceName = Brand<
    `/accounts/${GoogleMyBusinessAccountResourceId}/locations/${GoogleMyBusinessLocationResourceId}`,
    'GoogleMyBusinessLocationResourceName'
>;

export const GoogleMyBusinessLocationResourceName = Object.freeze({
    from(value: string): GoogleMyBusinessLocationResourceName {
        if (!GoogleMyBusinessLocationResourceName.matches(value)) {
            throw new TypeError(`Failed to parse invalid business location resource name: "${value}"`);
        }
        return value;
    },
    getBusinessLocationResourceId(
        resourceName: GoogleMyBusinessLocationResourceName,
    ): GoogleMyBusinessLocationResourceId {
        const match = BUSINESS_LOCATION_RESOURCE_NAME_REGEX.exec(resourceName);
        if (match && match.length && match[1]) {
            return GoogleMyBusinessLocationResourceId.from(match[1]);
        } else {
            throw new TypeError(`${resourceName} is not a BusinessLocationResourceName`);
        }
    },
    matches(value: string): value is GoogleMyBusinessLocationResourceName {
        return !!BUSINESS_LOCATION_RESOURCE_NAME_REGEX.exec(value);
    },
});
